export const enumToOptions = (enumObj: any) => {
    return Object.keys(enumObj)
      .filter(key => isNaN(Number(key)))
      .map(key => ({
        value: enumObj[key],
        label: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ')
      }));
  };
  